import Bowser from "bowser";
import { useIsMounted } from "usehooks-ts";

import { useMediaQueryBreakpoint } from "@hooks";

export function usePerformance() {
  const isSafari =
    typeof window !== "undefined" &&
    Bowser.parse(window.navigator.userAgent).browser.name === "Safari";
  const { isDesktop, isTablet } = useMediaQueryBreakpoint();
  const isMounted = useIsMounted();

  return {
    blurSupport: !isSafari && isDesktop && isMounted,
    splineSupport: (isTablet || isSafari) && isMounted,
    isMounted: isMounted(),
  };
}
